import api from './base';
import { GetListType } from './types/GetListType';

export enum HostFlowEnum {
  VISITS = 'VISITS',
  MEETINGS = 'MEETINGS',
  CREDENTIALING = 'CREDENTIALING',
  SPACE_MANAGEMENT = 'SPACE_MANAGEMENT',
  QRCODE = 'QRCODE',
}

class FlowRestrictionsApi {
  public getFlowRestrictions = async (companyId: string | null, params?: any) => {
    const response = await api.get(`/cfgCHType-flow-restrictions`, {
      params: { ...params, companyId },
    });

    return response.data;
  };
}

export default new FlowRestrictionsApi();
